import { Grid } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import { mdiAlertCircleOutline, mdiDelete, mdiDotsVertical } from '@mdi/js';
import Icon from '@mdi/react';
import ActionContainer from 'components/ActionContainer/ActionContainer';
import TextInput from 'components/TextInput/TextInput';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export const FirestopProductItem = ({
  firestopProduct,
  loading,
  openFirestopProductsArray,
  setOpenFirestopProductsArray,
  onChangeFirestopProduct,
  onDeleteFirestopProduct,
}) => {
  const { t } = useTranslation('common');
  const theme = useTheme();

  const open = useMemo(
    () => openFirestopProductsArray.includes(firestopProduct.id),
    [firestopProduct.id, openFirestopProductsArray]
  );

  const trimmedName = firestopProduct.name?.toString().trim() || '';
  const hasNameError = !trimmedName;

  const titleIcon = hasNameError ? (
    <Icon
      path={mdiAlertCircleOutline}
      size={1}
      color={theme.palette.error.main}
    />
  ) : null;

  const handleOpen = () => {
    if (open) {
      setOpenFirestopProductsArray(
        openFirestopProductsArray.filter((id) => id !== firestopProduct.id)
      );
      return;
    }

    setOpenFirestopProductsArray([
      ...openFirestopProductsArray,
      firestopProduct.id,
    ]);
  };

  return (
    <ActionContainer
      title={trimmedName || t('common.add_new')}
      closable
      closableDisabled={hasNameError}
      open={open}
      setOpen={handleOpen}
      color="main"
      popperIcon={<Icon path={mdiDotsVertical} size={1} />}
      popperChildren={<Icon path={mdiDelete} size={1} color="red" />}
      onPopper={() => onDeleteFirestopProduct(firestopProduct.id)}
      titleIcon={titleIcon}
      titleIconAlign="right"
    >
      <Grid item xs={12}>
        <TextInput
          label={t('common.name')}
          fullWidth
          value={firestopProduct.name || ''}
          onChange={(event) =>
            onChangeFirestopProduct(firestopProduct.id, event.target.value)
          }
          disabled={loading}
          required
          error={hasNameError}
        />
      </Grid>
    </ActionContainer>
  );
};

FirestopProductItem.propTypes = {
  firestopProduct: PropTypes.object.isRequired,
  loading: PropTypes.bool,
  openFirestopProductsArray: PropTypes.array.isRequired,
  setOpenFirestopProductsArray: PropTypes.func.isRequired,
  onChangeFirestopProduct: PropTypes.func.isRequired,
  onDeleteFirestopProduct: PropTypes.func.isRequired,
};

FirestopProductItem.defaultProps = {
  loading: false,
};
